/**
 * Partner Detail Actions
 *
 * Actions for managing the partner detail form in the NGXS store.
 */

import { Partner } from 'src/app/models/schema';

/**
 * Initialize partner detail form
 */
export class InitializePartnerDetail {
  static readonly type = '[PartnerDetail] Initialize';
}

/**
 * Set partner field value
 */
export class SetPartnerDetailField {
  static readonly type = '[PartnerDetail] Set Field';
  constructor(public field: keyof Partner, public value: any) {}
}

/**
 * Update multiple partner fields
 */
export class UpdatePartnerDetailFields {
  static readonly type = '[PartnerDetail] Update Fields';
  constructor(public updates: Partial<Partner>) {}
}

/**
 * Reset partner detail form
 */
export class ResetPartnerDetail {
  static readonly type = '[PartnerDetail] Reset';
}

/**
 * Set partner data (e.g., when loading existing partner)
 */
export class SetPartnerDetailData {
  static readonly type = '[PartnerDetail] Set Data';
  constructor(public partner: Partial<Partner>) {}
}

/**
 * Clear partner detail form
 */
export class ClearPartnerDetail {
  static readonly type = '[PartnerDetail] Clear';
}

